import { useTranslation } from 'react-i18next';

import Icon from '@material-ui/icons/CloudUpload';

import FloatIcon from 'components/icons/FloatIcon';

function ImportIcon({ onImport }: { onImport: () => any }) {
	const { t } = useTranslation();

	return <FloatIcon onClick={() => onImport()} title={t('common:import')} icon={Icon} />;
}

export default ImportIcon;
